module.exports = __webpack_public_path__ + "static/media/15.a4728e52.png";